import Fetch from '../utils/fetch'

export default {
  // 前三政策
  getPolicyTopThree(params) {
    return Fetch({
      url: '/isp-talent/policy/talentPolicy/getPolicyTopThree',
      data: params
    })
  },
  getHomePageProjectList(params) {
    return Fetch({
      url: '/isp-talent/talentproject/talentProject/getHomePageProjectList',
      data: params,
      type: 'POST'
    })
  },
  getProjectSearchPage(params) {
    return Fetch({
      url: '/isp-talent/talentproject/talentProject/getProjectSearchPage',
      data: params,
      type: 'POST'
    })
  },
  // 政策公告
  getPolicySearchPage(params) {
    return Fetch({
      url: '/isp-talent/policy/talentPolicy/getPolicySearchPage',
      data: params,
      type: 'POST'
    })
  },
  // 登录记录插入
  codeVisit(params) {
    return Fetch({
      url: '/isp-talent/talent/code/visit',
      data: params,
      type: 'POST'
    })
  },
  // 政策推荐
  getPolicyTalentPage(params) {
    return Fetch({
      url: '/isp-talent/policy/talentPolicy/queryUserPageList',
      data: params,
      type: 'GET'
    })
  },
  // 评审公示
  getTalentNoticePage(params) {
    return Fetch({
      url: '/isp-talent/notice/talentNotice/getTalentNoticePage',
      data: params,
      type: 'POST'
    })
  },
  // 政策公告
  talentPolicyList(params) {
    return Fetch({
      url: '/isp-talent/policy/talentPolicy/list',
      data: params,
      type: 'GET'
    })
  },
  // 服务对象菜单
  getServiceObjectList(params) {
    return Fetch({
      url: '/isp-talent/workmodules/workModules/getServiceObjectList',
      data: params,
      type: 'GET'
    })
  },
  // 人才类别菜单
  getTalentTypeList(params) {
    return Fetch({
      url: '/isp-talent/workmodules/workModules/getTalentTypeList',
      data: params,
      type: 'GET'
    })
  },
  // 待遇类型 下拉菜单
  getTreatmentTypeList(params) {
    return Fetch({
      url: '/isp-talent/workmodules/workModules/getTreatmentTypeList',
      data: params,
      type: 'GET'
    })
  },
  // 政策匹配
  getPolicyMatchList(params) {
    return Fetch({
      url: '/isp-talent/policy/talentPolicy/getPolicyMatchList',
      data: params,
      type: 'POST'
    })
  },
  // 人才项目
  getFinalStageProjectPage(params) {
    return Fetch({
      url: '/isp-talent/talentproject/talentProject/getFinalStageProjectPage',
      data: params,
      type: 'POST'
    })
  },
  // 评审公示详情
  noticeQueryById(params) {
    return Fetch({
      url: '/isp-talent/notice/talentNotice/queryById',
      data: params,
      type: 'GET'
    })
  },
  // 热词搜索
  getHotKeyWords(params) {
    return Fetch({
      url: '/isp-talent/common/server/getHotKeyWords',
      data: params,
      type: 'GET'
    })
  },
  // 热词计数
  addCount(params) {
    return Fetch({
      url: '/isp-talent/common/server/addCount',
      data: params,
      type: 'POST'
    })
  },
  // 政策公告详情
  policyQueryById(params) {
    return Fetch({
      url: '/isp-talent/policy/talentPolicy/queryById',
      data: params,
      type: 'GET'
    })
  },
  // 政策解读
  getPolicyInterpretationByPolicyId(params) {
    return Fetch({
      url: '/isp-talent/policy/talentPolicy/getPolicyInterpretationByPolicyId',
      data: params,
      type: 'POST'
    })
  },
  getUserInfo(params) {
    return Fetch({
      url: '/isp-talent/zjzw/getUserInfo',
      data: params,
      type: 'GET'
    })
  },
  getUserInfogroup(params) {
    return Fetch({
      url: '/declare/group-by-project',
      data: params,
      type: 'GET'
    })
  }
}
